import { AnaColumn } from "../forms-template.service";

export const licenze: AnaColumn[] = [
  {
    itemType: "group", colCount: "1", class: 'mt-5', data: [
      {
        type: 'buttonArray',
        dataField: "licenzaDetail",
        width: 50,
        hideOnEdit: true,
        disabled: true,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        buttonArray: [{
          event: "licenzaDetail",
          name: "licenzaDetail",
          hint: "Info Licenza",
          icon: "bi bi-info-square"
        },
        {
          event: "OptionalIconButtonClick",
          name: "licenzaUtenti",
          hint: "Gestione Utenti",
          icon: "bi bi-person-square"
        }
        ]
      },

      {
        type: 'campo',
        disabled: true,
        dataField: "id",
        dataType: "",
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        caption: "Licenza"
      },
      {
        type: 'campo',
        disabled: true,
        dataField: "descrizione",
        dataType: "",
        class: 'text-start',
        horizontalAlignment: 'start',
        colAlignment: 'start',
        caption: "Cliente",
        width: "400"
      },
      {
        type: 'campo',
        colVisible: false,
        hideOnEdit: true,
        dataField: "note",
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        dataType: "",
        colSpan: "2"
      },
      {
        type: 'campo',
        disabled: true,
        dataField: "codiceFiscale",
        caption: "Codice Fiscale",
        class: 'text-start',
        horizontalAlignment: 'start',
        colAlignment: 'start',
        dataType: "",
        colSpan: "2"
      },
      {
        type: 'campo',
        editorType: 'dxCheckBox',
        hideOnEdit: false,
        dataField: "isAttiva",
        caption: "Attiva",
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        dataType: "boolean",
        colSpan: "2"
      },
    ]
  },
];

export const attivaLicenza: AnaColumn[] = [


  {
    itemType: "group", colCount: "1", groupWidth: 900, data: [

      {
        type: 'campo', dataField: "codiceAssistenza", dataType: "", caption: "Codice Assistenza", validation: [
          { type: "required", message: "Campo Codice Assistenza obbligatorio." },
        ],
        // button: {
        //   text: '',
        //   name: 'mostraPasswordAttuale',
        //   //class:'customBrightness',
        //   location: 'after',
        //   event: "mostraPasswordAttuale",
        //   hint: "Mostra Password",
        //   icon: "assets/icons/MOSTRA_PASSWORD.svg",
        // },
      },
      {
        type: 'campo',
        dataField: 'ragioneSociale',
        caption: 'Ragione Sociale',
        validation: [{
          type: 'required', message: 'Campo Ragione Sociale obbligatorio.'
        }]
      },
      {
        type: 'campo',
        dataField: 'codiceFiscale',
        caption: 'Codice Fiscale',
        validation: [{
          type: 'required', message: 'Campo Codice Fiscale obbligatorio.'
        }]
      },
      {
        type: 'campo',
        dataField: "numeroMaxDispositiviMobili",
        class: 'database_consultant',
        width: 300,
        labelWidth: 200,
        caption: "Max dispositivi App"

      },
      {
        type: 'campo',
        class: 'database_consultant',
        dataField: "quotaConsulentiInMegaBytes",
        caption: "Quota consulenti(MB)"
      },
    ]
  }
]
